import styled from 'styled-components';
import { styles } from '@sdir/sds';

export const InputError = styled.div`
  color: ${styles.colors.alert.errorHot};
  margin-top: 0.25em;
  padding: 0 2rem;
  font-family: ${styles.fonts.stfMedium};
  font-size: 14px;
  line-height: 1.5;
`;
